import React, { useState } from "react";
import styles from "./styles.module.css";
import { HiPlus } from "react-icons/hi";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
import { Modal } from "antd";

const Footer = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const showModal = (content) => {
    setModalContent(content);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className={styles.footerWrap}>
      <div className={styles.footer}>
        <div className={styles.subscribeDiv}>
          <p className={styles.FH}>LORMAMI</p>
          <p className={styles.first2}>
            01, Animashaun street, <br /> Progressive Estate, Ojodu Berger
          </p>
        </div>
        <div className={styles.subscribeDiv}>
          <p className={styles.FH1}>LINKS</p>
          <p
            className={styles.second24}
            onClick={() =>
              showModal(
                "REFUND AND RETURN POLICY\n\nWe do not accept refunds or returns, however orders can be switched (before production starts) to an item of the same value. Thank you for wearing Lormami."
              )
            }
          >
            Return and Refund Policy
          </p>
          <p
            className={styles.second24}
            onClick={() =>
              showModal(
                "PAYMENT AND DELIVERY\n\nProduction and delivery takes 14-21 days after payment is confirmed. Extra delivery charges may occur for delivery. Thank you for wearing Lormami."
              )
            }
          >
            Payment and Delivery
          </p>
          <p
            className={styles.second24}
            onClick={() =>
              showModal(
                "COMMITMENT TO THE ENVIRONMENT\n\nAt Lormami, the environment is our canvas and we draw inspiration from the environment and as such sustainable environmental practices are essential to us, this is shown in our recycling/upcycling jobs amongst others."
              )
            }
          >
            Commitment to the Environment
          </p>
        </div>
        <div className={styles.subscribeDiv}>
          <p className={styles.FH1}>SUBSCRIBE</p>
          <p className={styles.second3}>
            Get updates on discounts and product drops
          </p>
          <div className={styles.inputH}>
            <input
              type="text"
              className={styles.input}
              placeholder="Enter Email Address"
            />
            <span className={styles.HiP}>
              <HiPlus color="fff" cursor="pointer" />
            </span>
          </div>
        </div>
      </div>
      <div className={styles.footerB}>
        <p className={styles.second2}>+23409068600435</p>
        <p className={styles.second24}>
          <AiOutlineCopyrightCircle fontSize={14} />
          2023 All Rights Reserved
        </p>
        <p className={styles.underLine}>contact@wearlormami.com</p>
      </div>
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        className={styles.modal}
      >
        <div className={styles.modalContent}>{modalContent}</div>
      </Modal>
    </div>
  );
};

export default Footer;